import { translate } from 'react-i18next';
import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const LanguageSelector = (props) => {
  const { i18n } = props;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  
  return (
    <UncontrolledDropdown
      tag="ul"
      className="navbar-nav flex-row ml-md-auto d-md-flex"
    >
      <li className="nav-item dropdown">
        <DropdownToggle
          tag="a"
          href="javascript:void(0);"
          className="nav-item nav-link dropdown-toggle mr-md-2"
          caret
        >
          Language
        </DropdownToggle>
        <DropdownMenu left={'true'} className="dropdown-menu-right">
          <DropdownItem header>Select language</DropdownItem>
          <DropdownItem onClick={() => changeLanguage('en')}>English</DropdownItem>
          <DropdownItem onClick={() => changeLanguage('sv')}>Swedish</DropdownItem>
        </DropdownMenu>
      </li>
    </UncontrolledDropdown>
  );
};

export default translate()(LanguageSelector);



// WEBPACK FOOTER //
// ./src/components/LanguageSelector.js